import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar.js";
// เพิ่ม loading เข้ามาในนี้
import {
    tokens, total, success_url, toFixed, GET, PUT,
    format_date, DatePicker, getStorage, loading, alert_2
} from "../../components/CustomComponent.js";
import React, { Component } from "react";

// รายการที่เลือกตัดได้ในโหมด "เลือกตัดเฉพาะรายการ"
const CUT_FIELDS = [
    { key: "water_bill", label: "ค่าน้ำประปา" },
    { key: "equipment_maintenance_fee", label: "ค่ารักษาอุปกรณ์น้ำ" },
    { key: "common_expenses", label: "ค่าส่วนกลาง" },
    { key: "waste_cost", label: "ค่าขยะ" },
    { key: "cable_cost", label: "ค่าเคเบิล" },
    { key: "other_income", label: "ค่าใช้จ่ายอื่นๆ" },
    { key: "fire_cost", label: "ค่าเบี้ยประกัน" },
    { key: "debt_adjust", label: "เพิ่ม/ลดหนี้", compute: (item) => (item.add_debt || 0) - (item.reduce_debt || 0) },
    { key: "meter_connect_cost", label: "ค่าต่อกลับมิเตอร์" },
    { key: "total_cost_late", label: "ค่าปรับชำระล่าช้า" },
    { key: "adjustment", label: "ปรับปรุงยอดเงิน", compute: () => 0 },
];

export default class WriteOfDept extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            search: "",
            data: null,
            date: new Date(),
            address_number: "",
            full_name: "",
            ref_cause: "1",
            ref_remark: "",
            total: 0,
            ref_iw_number: "",
            ref_record_date: "",
            cut_mode: "old" // "old" = ตัดทั้งยอด (เดิม), "new" = เลือกตัดเฉพาะรายการ
        };
    }

    async componentDidMount() {
        loading(false); // เรียกใช้งานทันทีตั้งแต่เข้ามาหน้าแรก
        
        const address_number = this.props.location?.query?.address_number;
        if (address_number) {
            await this.GetById(address_number);
        }
    }

    GetById = async (address_number) => {
        let fields = [
            { k: "water_bill", sk: "s_water_bill" }, { k: "waste_cost", sk: "s_waste_cost" },
            { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" }, { k: "common_expenses", sk: "s_common_expenses" },
            { k: "cable_cost", sk: "s_cable_cost" }, { k: "fire_cost", sk: "s_fire_cost" },
            { k: "other_income", sk: "s_other_income" }, { k: "add_debt", sk: "s_add_debt" },
            { k: "meter_connect_cost", sk: "s_meter_connect_cost" }, { k: "reduce_debt", sk: "s_reduce_debt", m: -1 },
            { k: "total_cost_late", sk: "s_late_payment", pk: "late_payment" }
        ];
        loading(true);

        const projectId = getStorage("project_id");
        let result = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${projectId}`, { address_number });
        
        if (result?.status) {
            if (!result.data.data_water.length) {
                window.location.href = "/water-payment-info";
                return;
            }
            let resData = result.data.data_water;
            for (let item of resData) {
                // writeoff_list
                if (item.writeoff_list?.length > 0) {
                    if (item.writeoff_list.some((p) => p.s_water_bill)) {
                        item.water_bill = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_waste_cost)) {
                        item.waste_cost = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_reduce_debt)) {
                        item.reduce_debt = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_other_income)) {
                        item.other_income = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_meter_connect_cost)) {
                        item.meter_connect_cost = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_late_payment)) {
                        item.total_cost_late = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_fire_cost)) {
                        item.fire_cost = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_equipment_maintenance_fee)) {
                        item.equipment_maintenance_fee = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_common_expenses)) {
                        item.common_expenses = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_cable_cost)) {
                        item.cable_cost = 0;
                    }
                    if (item.writeoff_list.some((p) => p.s_add_debt)) {
                        item.add_debt = 0;
                    }
                    item.total_amount =
                        item.water_bill +
                        item.waste_cost +
                        item.other_income +
                        item.meter_connect_cost +
                        item.total_cost_late +
                        item.fire_cost +
                        item.equipment_maintenance_fee +
                        item.common_expenses +
                        item.cable_cost +
                        item.add_debt -
                        item.reduce_debt;
                }
            }
            
            // ช่องนี้จบแล้วหรือยัง — ยึด transaction_payments/writeoff_list เท่านั้น ไม่อ่าน s_* ระดับงวด
            // หลังยกเลิกการตัดหนี้/ยกเลิกใบเสร็จ backend ไม่ได้ล้าง s_* ยอดที่กลับมาค้างจะตัดหนี้ซ้ำไม่ได้
            const isSettled = (item, sk) =>
                [item.transaction_payments, item.writeoff_list].some((list) => list?.some((p) => p[sk]));

            resData = result.data.data_water.map(d => {
                ['total_cost_late', 'common_expenses', 'cable_cost', 'fire_cost'].forEach(k => d[k] = Number(String(d[k] || 0).replace(/,/g, "")));
                let total = 0;

                fields.forEach(({ k, sk, m = 1, pk }) => {
                    let targetKey = pk || k;
                    d[sk] = isSettled(d, sk); // sync ให้ตาราง/ยอดรวมใช้สถานะเดียวกัน
                    if (!d[sk]) total += (d[targetKey] || 0) * m;
                    else d[targetKey] = 0;
                });

                // ค่าปรับชำระล่าช้า: backend ตัวนี้ส่งมาในชื่อ total_cost_late (ลูปด้านบนใช้ pk = late_payment จึงบวกได้ 0)
                // ต้องเช็คสถานะด้วย ไม่งั้นค่าปรับที่เก็บ/ตัดหนี้ไปแล้วจะถูกนับซ้ำในยอดที่ตัดได้
                if (!d.s_late_payment) total += d.total_cost_late;
                else d.total_cost_late = 0;


                return {
                    ...d,
                    total_amount: total,
                    sel: CUT_FIELDS.reduce((acc, f) => { acc[f.key] = false; return acc; }, {})
                };
            }).sort((a, b) => new Date(a.datetime_create) - new Date(b.datetime_create));

            this.setState({
                data: resData,
                address_number: resData[0].address_number,
                full_name: resData[0].full_name
            });
        }
        loading(false);
    }

    Update = async () => {
        loading(true);
        const { data, ref_iw_number, ref_record_date, ref_cause, ref_remark } = this.state;
        
        let payload = {
            record_water_list: (data || []).filter(item => item.selected).map(item => item.record_water_id),
            ref_iw_number,
            ref_record_date,
            ref_cause: Number(ref_cause),
            ref_remark,
        };

        let result = await PUT(tokens, `v1/TH/record-water/clear-bill/${getStorage("project_id")}`, payload);
        if (result?.status) {
            success_url("/water-payment-info");
        }
        loading(false);
    }

    // ===== บันทึกโหมด "เลือกตัดเฉพาะรายการ" — คนละ endpoint กับ Update() ด้านบน ไม่ยุ่งกับโหมดเดิม =====
    UpdateItem = async () => {
        const { data, ref_iw_number, ref_record_date, ref_cause, ref_remark } = this.state;

        const items = (data || [])
            .map(item => {
                const sel = item.sel || {};
                const selected = {
                    water_bill: !!sel.water_bill,
                    equipment_maintenance_fee: !!sel.equipment_maintenance_fee,
                    common_expenses: !!sel.common_expenses,
                    waste_cost: !!sel.waste_cost,
                    cable_cost: !!sel.cable_cost,
                    other_income: !!sel.other_income,
                    fire_cost: !!sel.fire_cost,
                    add_debt: !!sel.debt_adjust,
                    reduce_debt: !!sel.debt_adjust,
                    meter_connect_cost: !!sel.meter_connect_cost,
                    total_cost_late: !!sel.total_cost_late,
                    adjustment: !!sel.adjustment,
                };
                if (!Object.values(selected).some(Boolean)) return null;
                return {
                    record_water_id: item.record_water_id,
                    selected,
                    adjustment_amount: sel.adjustment ? this.getFieldValue(item, CUT_FIELDS.find(f => f.key === "adjustment")) : 0
                };
            })
            .filter(Boolean);

        if (items.length === 0) {
            await alert_2("", "warning", "ยังไม่ได้เลือกรายการ", "กรุณาเลือกรายการที่ต้องการตัดหนี้ก่อน");
            return;
        }

        loading(true);

        let payload = {
            items,
            ref_iw_number,
            ref_record_date,
            ref_cause: Number(ref_cause),
            ref_remark,
        };

        let result = await PUT(tokens, `v1/TH/record-water/clear-bill-item/${getStorage("project_id")}`, payload);
        if (result?.status) {
            success_url("/water-payment-info");
        }
        loading(false);
    }

    handleSubmit = async () => {
        const { total, cut_mode } = this.state;
        const confirmed = await alert_2(
            "",
            "warning",
            "ยืนยันการตัดหนี้",
            `ต้องการตัดหนี้ยอด ฿${total ? toFixed(total) : "0.00"} ใช่หรือไม่?`,
            "ยืนยัน",
            "ยกเลิก"
        );
        if (!confirmed) return;

        if (cut_mode === "new") await this.UpdateItem();
        else await this.Update();
    }

    clear_form = () => {
        this.setState({ page: 1, search: "", data: null, total: 0 });
    }

    cal_total = () => {
        const selectedData = (this.state.data || []).filter(item => item.selected);
        this.setState({ total: total(selectedData, "total_amount") });
    }

    switchMode = async (mode) => {
        const { cut_mode, total: currentTotal, data } = this.state;
        if (mode === cut_mode) return;

        if (currentTotal > 0) {
            const confirmed = await alert_2(
                "",
                "warning",
                "เปลี่ยนรูปแบบการตัดยอด",
                "การสลับรูปแบบจะล้างรายการที่เลือกไว้ทั้งหมด ต้องการดำเนินการต่อหรือไม่?",
                "เปลี่ยนรูปแบบ",
                "ยกเลิก"
            );
            if (!confirmed) return;
        }

        const clearedData = (data || []).map(item => ({
            ...item,
            selected: false,
            sel: CUT_FIELDS.reduce((acc, f) => { acc[f.key] = false; return acc; }, {})
        }));
        this.setState({ cut_mode: mode, data: clearedData, total: 0 });
    }

    // ===== โหมด "เลือกตัดเฉพาะรายการ" =====
    getFieldValue = (item, field) => field.compute ? field.compute(item) : (item[field.key] || 0);

    cal_total_new = () => {
        const { data } = this.state;
        let sum = 0;
        (data || []).forEach(item => {
            CUT_FIELDS.forEach(field => {
                if (item.sel && item.sel[field.key]) sum += this.getFieldValue(item, field);
            });
        });
        this.setState({ total: sum });
    }

    getRowMasterState = (item) => {
        const selectable = CUT_FIELDS.filter(f => this.getFieldValue(item, f) !== 0);
        if (!selectable.length) return "none";
        const selectedCount = selectable.filter(f => item.sel && item.sel[f.key]).length;
        if (selectedCount === 0) return "none";
        if (selectedCount === selectable.length) return "all";
        return "partial";
    }

    toggleColumnAll = (fieldKey, checked) => {
        const field = CUT_FIELDS.find(f => f.key === fieldKey);
        const newData = (this.state.data || []).map(item => {
            if (this.getFieldValue(item, field) === 0) return item;
            return { ...item, sel: { ...item.sel, [fieldKey]: checked } };
        });
        this.setState({ data: newData }, this.cal_total_new);
    }

    toggleRowMaster = (index, checked) => {
        const newData = [...this.state.data];
        const item = newData[index];
        const newSel = { ...item.sel };
        CUT_FIELDS.forEach(field => {
            if (this.getFieldValue(item, field) !== 0) newSel[field.key] = checked;
        });
        newData[index] = { ...item, sel: newSel };
        this.setState({ data: newData }, this.cal_total_new);
    }

    toggleCell = (index, fieldKey, checked) => {
        const newData = [...this.state.data];
        newData[index] = { ...newData[index], sel: { ...newData[index].sel, [fieldKey]: checked } };
        this.setState({ data: newData }, this.cal_total_new);
    }

    render() {
        const { data, date, address_number, full_name, ref_cause, ref_remark, total, ref_iw_number, ref_record_date, cut_mode } = this.state;
        const fmt = (val) => val ? toFixed(val) : "0.00"; // Helper สำหรับ render ตัวเลข
        const allSelected = data && data.length > 0 && data.every(item => item.selected);
        const rowSelectedList = cut_mode === "new" ? (data || [])
            .map(item => ({
                date: item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-",
                sum: CUT_FIELDS.reduce((s, f) => s + (item.sel && item.sel[f.key] ? this.getFieldValue(item, f) : 0), 0)
            }))
            .filter(row => row.sum !== 0) : [];
        const hasSelection = cut_mode === "new"
            ? rowSelectedList.length > 0
            : !!(data && data.some(item => item.selected));

        return (
            <div className="w-100 min-vh-100 fade-in">
                <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="บันทึกรายรับอื่นๆ" />

                {/* BODY */}
                <div className="body">
                    <div className="p-3 mx-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between">
                            <h4 className="mb-3"><b>การตัดลูกหนี้</b></h4>
                            <button className="btn btn-outline-primary px-4 mx-1 mb-2" onClick={() => { window.location.href = "/water-payment-info" }}>ย้อนกลับ</button>
                        </div>

                        {/* สลับโหมดการตัดยอด */}
                        <div className="d-flex align-items-center mb-3">
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className={`mr-2 btn btn-sm ${cut_mode === "old" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => this.switchMode("old")}
                                >ตัดทั้งยอด (เดิม)</button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${cut_mode === "new" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => this.switchMode("new")}
                                >เลือกตัดเฉพาะรายการ (ใหม่)</button>
                            </div>
                        </div>

                        {/* วันที่ บ้านเลขที่ ชื่อ - นามสกุล */}
                        <div className="card border-0 px-3 pt-3 mb-3">
                            <div className="row">
                                <div className="col-12 col-md-4 mb-3">
                                    <label>วันที่</label>
                                    <input type="text" className="form-control w-100 bg-contain border-0" value={format_date(date, "dd/mm/yyyy")} readOnly />
                                </div>
                                <div className="col-12 col-md-4 mb-3">
                                    <label>บ้านเลขที่</label>
                                    <input type="text" className="form-control w-100 bg-contain border-0" value={address_number} readOnly />
                                </div>
                                <div className="col-12 col-md-4 mb-3">
                                    <label>ชื่อ - นามสกุล</label>
                                    <input type="text" className="form-control w-100 bg-contain border-0" value={full_name} readOnly />
                                </div>
                            </div>
                        </div>

                        {/* ตาราง */}
                        <div className="card border-0 p-3 mb-3">
                            <div className="table-responsive">
                                {cut_mode === "old" ? (
                                <table key="old" className="table table-borderless table-striped text-nowrap">
                                    <thead className="bg-dark-blue text-white">
                                        <tr className="bg-primary">
                                            <th className="text-center wpx-100">
                                                <label className="d-flex align-items-center justify-content-center pointer mb-0" style={{ gap: 6 }}>
                                                    <input
                                                        type="checkbox"
                                                        className="pointer"
                                                        checked={allSelected || false}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            const newData = data.map(d => ({ ...d, selected: checked }));
                                                            this.setState({ data: newData }, this.cal_total); // ใช้ Callback
                                                        }}
                                                    />
                                                    <span>เลือก</span>
                                                </label>
                                            </th>
                                            <th className="text-center wpx-100">วันที่จดมาตร</th>
                                            <th className="text-center">เลขมาตรครั้งนี้</th>
                                            <th className="text-center">เลขมาตรครั้งก่อน</th>
                                            <th className="text-right">จำนวนหน่วยที่ใช้</th>
                                            <th className="text-right">ค่าน้ำประปา</th>
                                            <th className="text-right">ค่ารักษาอุปกรณ์น้ำ</th>
                                            <th className="text-right">ค่าส่วนกลาง</th>
                                            <th className="text-right">ค่าขยะ</th>
                                            <th className="text-right">ค่าเคเบิล</th>
                                            <th className="text-right">ค่าใช้จ่ายอื่นๆ</th>
                                            <th className="text-right">ค่าเบี้ยประกัน</th>
                                            <th className="text-right">เพิ่ม/ลดหนี้</th>
                                            <th className="text-right">ค่าต่อกลับมิเตอร์</th>
                                            <th className="text-right">ค่าปรับชำระล่าช้า</th>
                                            <th className="text-right">ปรับปรุงยอดเงิน</th>
                                            <th className="text-right">รวมยอดเงิน</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        className="pointer"
                                                        checked={item.selected}
                                                        onChange={(e) => {
                                                            let newData = [...data];
                                                            newData[index].selected = e.target.checked;
                                                            this.setState({ data: newData }, this.cal_total); // ใช้ Callback
                                                        }}
                                                    />
                                                </td>
                                                <td className="text-center wpx-100">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-center">{item.current_gauge_number || "0"}</td>
                                                <td className="text-center">{item.last_gauge_number || "0"}</td>
                                                <td className="text-right">{item.unit_used || "-"}</td>
                                                <td className="text-right">{fmt(item.water_bill)}</td>
                                                <td className="text-right">{fmt(item.equipment_maintenance_fee)}</td>
                                                <td className="text-right">{fmt(item.common_expenses)}</td>
                                                <td className="text-right">{fmt(item.waste_cost)}</td>
                                                <td className="text-right">{fmt(item.cable_cost)}</td>
                                                <td className="text-right">{fmt(item.other_income)}</td>
                                                <td className="text-right">{fmt(item.fire_cost)}</td>
                                                <td className="text-right">{fmt((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                                                <td className="text-right">{fmt(item.meter_connect_cost)}</td>
                                                <td className="text-right">{fmt(item.total_cost_late)}</td>
                                                <td className="text-right">0.00</td>
                                                <td className="text-right">{fmt(item.total_amount)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                ) : (
                                <table key="new" className="table table-borderless table-striped text-nowrap">
                                    <thead className="bg-dark-blue text-white">
                                        <tr className="bg-primary">
                                            <th className="text-center wpx-100">เลือกแถว</th>
                                            <th className="text-center wpx-100">วันที่จดมาตร</th>
                                            <th className="text-center">เลขมาตรครั้งนี้</th>
                                            <th className="text-center">เลขมาตรครั้งก่อน</th>
                                            <th className="text-right">จำนวนหน่วยที่ใช้</th>
                                            {CUT_FIELDS.map(field => {
                                                const values = (data || []).map(item => this.getFieldValue(item, field));
                                                const colAllZero = values.every(v => v === 0);
                                                const colChecked = !colAllZero && (data || []).every(item => this.getFieldValue(item, field) === 0 || (item.sel && item.sel[field.key]));
                                                return (
                                                    <th className="text-right" key={field.key}>
                                                        <label className="d-flex flex-row align-items-end pointer mb-0">
                                                            <span>{field.label}</span>
                                                            <input
                                                                type="checkbox"
                                                                className="ml-2 mt-1 pointer"
                                                                disabled={colAllZero}
                                                                checked={colChecked}
                                                                onChange={(e) => this.toggleColumnAll(field.key, e.target.checked)}
                                                            />
                                                        </label>
                                                    </th>
                                                );
                                            })}
                                            <th className="text-right">รวมยอดที่เลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.map((item, index) => {
                                            const rowState = this.getRowMasterState(item);
                                            let rowSelectedTotal = 0;
                                            CUT_FIELDS.forEach(field => { if (item.sel && item.sel[field.key]) rowSelectedTotal += this.getFieldValue(item, field); });
                                            return (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            className="pointer"
                                                            ref={el => { if (el) el.indeterminate = rowState === "partial"; }}
                                                            checked={rowState === "all"}
                                                            onChange={(e) => this.toggleRowMaster(index, e.target.checked)}
                                                        />
                                                    </td>
                                                    <td className="text-center wpx-100">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-"}</td>
                                                    <td className="text-center">{item.current_gauge_number || "0"}</td>
                                                    <td className="text-center">{item.last_gauge_number || "0"}</td>
                                                    <td className="text-right">{item.unit_used || "-"}</td>
                                                    {CUT_FIELDS.map(field => {
                                                        const val = this.getFieldValue(item, field);
                                                        const checked = !!(item.sel && item.sel[field.key]);
                                                        return (
                                                            <td className="text-right" key={field.key}>
                                                                <label className="d-flex align-items-center justify-content-end pointer mb-0">
                                                                    <span className={checked ? "text-primary font-weight-bold mr-2" : val === 0 ? "text-muted mr-2" : "mr-2"}>{fmt(val)}</span>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="pointer"
                                                                        disabled={val === 0}
                                                                        checked={checked}
                                                                        onChange={(e) => this.toggleCell(index, field.key, e.target.checked)}
                                                                    />
                                                                </label>
                                                            </td>
                                                        );
                                                    })}
                                                    <td className="text-right"><b>{fmt(rowSelectedTotal)}</b></td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                )}
                            </div>
                        </div>

                        {/* ยอดตัดหนี้ */}
                        <div className="card border-0 p-3 mb-3">
                            <div className="w-100">
                                <b className="mb-2">ยอดตัดหนี้</b>
                                <h4><b>฿{fmt(total)}</b></h4>
                                {cut_mode === "new" && (
                                    <div className="mt-2">
                                        {rowSelectedList.length === 0 ? (
                                            <div className="text-muted small">ยังไม่ได้เลือกรายการ</div>
                                        ) : rowSelectedList.map((row, i) => (
                                            <div key={i} className="d-flex justify-content-start border-top py-1">
                                                <span className="small">{row.date}</span>
                                                <span className="text-muted mx-2 d-flex align-items-center">
                                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                                        <polyline points="12 5 19 12 12 19"></polyline>
                                                    </svg>
                                                </span>
                                                <span className="small">฿{fmt(row.sum)}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* สาเหตุ หมายเหตุเพิ่มเติม */}
                        <div className="card border-0 px-3 pt-3 mb-3">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <label>สาเหตุ</label>
                                    <select className="form-control bg-contain border-0" onChange={(e) => this.setState({ ref_cause: e.target.value })} value={ref_cause}>
                                        <option value="1">ลูกค้าชำระแล้ว</option>
                                        <option value="2">ลูกค้าเปลี่ยนสัญญา (บรรจุใหม่) ห้อง กคช.</option>
                                        <option value="3">ลูกค้าบรรจุใหม่ ซื้อขายโอนกรรมสิทธิ์</option>
                                    </select>
                                </div>
                                <div className="col-12 mb-3">
                                    <label>หมายเหตุเพิ่มเติม</label>
                                    <input type="text" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ ref_remark: e.target.value })} value={ref_remark} />
                                </div>
                            </div>
                        </div>

                        {/* เอกสารอ้างอิง */}
                        <div className="card border-0 px-3 pt-3 mb-3">
                            <h4 className="mb-3"><b>เอกสารอ้างอิง</b></h4>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label>เลขที่ใบเสร็จ</label>
                                    <input type="text" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ ref_iw_number: e.target.value })} value={ref_iw_number} />
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <label>วันออกใบเสร็จ</label>
                                    <DatePicker className="form-control bg-contain border-0 w-100" placeholder="กรอกข้อมูล" position="top" onChange={(e) => this.setState({ ref_record_date: e })} value={ref_record_date} />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button
                                className="btn btn-primary mb-4 wpx-200"
                                disabled={!hasSelection}
                                onClick={this.handleSubmit}
                            >ตัดหนี้</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}